import React from 'react';
import Row from '../tag/Row';
import Span from '../tag/Span';
import FlowmedikCareConversation from './FlowmedikCareConversation';
import Logger from '../../utils/Logger';
import { withPageBase } from '../PageBase';

let { id: module_id } = module;
const logger = new Logger(module_id);

const FlowmedikCareConversationPage = () => {
  return (
    <>
      <Row>
        <Span len="12" len-sm="12" className={'ot-careconversations-main'}>
          <FlowmedikCareConversation />
        </Span>
      </Row>
    </>
  );
};

export default withPageBase(FlowmedikCareConversationPage,
  {
    title: `${module_id}.title`
  }
);
